import { FilterConditionOutput } from '@components/ui/AdvancedFilter';
import { SortConfig } from '@components/ui/VirtualTable';

// Filtros para búsqueda de impresoras
export interface Filters {
  searchTerm?: string;

  // Filtros específicos
  status?: string | string[];
  active?: boolean | boolean[];
  computer?: string | string[];

  // Ordenamiento y paginación
  sortBy?: string;
  sortDirection?: 'asc' | 'desc';
  page?: number;
  limit?: number;
}

// 🎯 Función auxiliar para mapear filtros dinámicos desde el componente
export const mapFilterConditionsToPrinterFilters = (
  conditions: FilterConditionOutput[],
  sorting: SortConfig | null
): Filters => {
  const filters: Filters = {};

  conditions.forEach((condition) => {
    if (condition.column === 'status' && condition.action === 'equals') {
      filters.status = condition.value;
    }

    if (condition.column === 'active' && condition.action === 'equals') {
      filters.active = condition.value === 'true';
    }

    if (condition.column === 'computer' && condition.action === 'equals') {
      filters.computer = condition.value;
    }
  });

  if (sorting?.field) {
    filters.sortBy = sorting.field;
    filters.sortDirection = sorting.direction ?? 'desc';
  }

  return filters;
};
